import {FC} from 'react';
import {useAppSelector} from 'src/app/hooks';
import {CableLockToggle} from '../CableLockToggle';
import {ChargerDriverActionsType} from './ChargerDriverActions.types';

export const ChargerDriverActions: FC<ChargerDriverActionsType> = ({data}) => {
    const {authInfo} = useAppSelector((state) => state.common);

    // No divider and no grid row: this lives inside the device card now, beside the reset buttons,
    // rather than as a strip appended to the record of what the charger is.
    return (
        <CableLockToggle
            chargerId={data.id}
            businessId={data.business.id}
            companyId={authInfo?.company?.id}
            chargerStatus={data.currentStatus}
        />
    );
};
